require('./bootstrap')

window.Vue = require('vue').default

require('./../vendor/talvbansal/media-manager/js/media-manager')

import { App, plugin } from '@inertiajs/inertia-vue'
import Vue from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import VueSimpleAlert from "vue-simple-alert"
import Util from './util'
import Session from '@components/SessionComponent'
import _ from 'lodash'
export const EventBus = new Vue()

Vue.use(plugin)
    .use(VueSimpleAlert)
    .mixin({ methods: { route } })
    .mixin({
        computed: {
            tself() {return this}
        },
        methods: {
            getTrans($key, $default = null) {
                return _.get(
                    this,
                    `trans.${this.$state.localization}.${$key}`,
                    $default
                )
            }
        }
    })

Vue.prototype.$Util = Util

Vue.prototype._ = _

Vue.prototype.$onGlobal = function(event, f) {
    this.$root.$on(event, f)

    this.$once('hook:beforeDestroy', () => {
        this.$root.$off(event, f)
    })
}

Vue.prototype.$session = new Vue(Session)

const state = Vue.observable({...window.$frontend_data, ...{
    loaded: false,
    windowWidth: 0,
    navbarHeight: 0,
    footerHeight: 0,
    showCookieNoticeBanner: false,
    useMediaManager: true,
    showMediaManager: false,
    recaptchaIsLoaded: false,
    editor: 'ckeditor-custom',
    hasModule: function(m) {return this.modules.includes(m)},
    scrollY: 0
}})

Object.defineProperty(Vue.prototype, '$state', {
    get () { return state },
    set (value) { state = value }
})

const el = document.getElementById('app')

InertiaProgress.init()

window.app = new Vue({
    render: h => h(App, {
        props: {
            initialPage: JSON.parse(el.dataset.page),
            //resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
            resolveComponent: (component) => {
                let parts = component.split('/')
                let path = parts[0] == 'Modules'
                    ? parts.slice(2).join('/')
                    : parts.join('/')

                if(parts[0] == 'Modules') {
                    return import(`@modulesPages/${parts[1]}/Resources/assets/js/Pages/${path}.vue`).then(module => module.default)
                }

                return import(`@pages/${path}`).then(module => module.default)
            }
        }
    }),

    computed: {
        viewport() {
            if(this.$state.windowWidth >= this.$Util.overview().xl) {
                return 'xl'
            }

            if(this.$state.windowWidth >= this.$Util.overview().lg) {
                return 'lg'
            }

            if(this.$state.windowWidth >= this.$Util.overview().md) {
                return 'md'
            }

            if(this.$state.windowWidth >= this.$Util.overview().sm) {
                return 'sm'
            }

            return 'xs'
        }
    },

    methods: {
        userUpdated(user) {
            if(this.$state.user.id === user.id) {
                this.$state.user = user
            }
        },

        showMessage() {
            let urlParams = this.$state.urlParams
            let message_body = urlParams.get('message_body')

            if(message_body) {
                let message_title = urlParams.get('message_title')
                let message_type = urlParams.get('message_type')

                // this.$alert(
                //     message_body,
                //     message_title ? message_title : 'Aviso',
                //     message_type ? message_type : 'info'
                // )

                this.$set(this.$state.site, 'alert', {
                    message_title: message_title,
                    message_body: message_body,
                    message_type: message_type,
                    message_action_url: urlParams.get('message_action_url'),
                    message_action_text: urlParams.get('message_action_text')
                })
            }
        },

        isUrl(urls) {
            let firstSection = false

            try {
                firstSection = this.$page.url.split('/')[1].split('?')[0]
            } catch(e) {
                return false
            }

            urls = typeof urls == 'string' ? [urls] : urls

            for (var url of urls) {
                if(url == firstSection) {
                    return true
                }
            }

            return false
        }
    },

    watch: {
        '$state.navbarHeight'(navbarHeight) {
            document.documentElement.style.setProperty('--navbar-height', `${navbarHeight}px`)
        },

        '$state.footerHeight'(footerHeight) {
            document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`)
        }
    },

    mounted() {
        this.$root.$on('users.updated', this.userUpdated)

        this.$state.windowWidth = window.innerWidth
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.$state.windowWidth = window.innerWidth
            })
        })

        window.addEventListener('load', () => {
            this.$state.loaded = true
        })

        this.$set(this.$state, 'scrollY', window.scrollY)
        window.addEventListener('scroll', () => {
            this.$set(this.$state, 'scrollY', window.scrollY)
        })

        if(this.$state.messages) {
            let message = this.$state.messages[0]
            this.$alert(message.message, message.title, message.type)
        }

        this.$set(this.$state, 'urlParams', new URLSearchParams(window.location.search))

        this.showMessage()

        EventBus.$on('root', (event, args) => {
            this.$root.$emit(event, args)
        })
    }
})

require('./includes/breeze')
require('./includes/bv')
require('./includes/base')
require('./includes/auth')
require('./includes/searchables')
require('./includes/modules')

app.$mount(el)
